/* eslint-disable */
// AUTO-GENERATED FILE. DO NOT EDIT.
// Source: config/routes/canonical-routes.json

export type PrefixRewriteRule = {
  fromPrefix: string;
  toPrefix: string;
  defaultPath?: string;
};
export const CANONICAL_ROUTE_POLICY_VERSION = "1.0.0";

export const CANONICAL_ROUTE_POLICY_UPDATED = "2026-05-15";

export const RUNTIME_CANONICAL_SHELL_PREFIXES: string[] = [
  "/school/assistant",
  "/school/admissions",
  "/school/attendance",
  "/school/academics",
  "/school/camps",
  "/school/donations",
  "/school/faculty",
  "/school/finance",
  "/school/financialaid",
  "/school/payroll",
  "/school/run-reports",
  "/school/settings",
  "/school/students",
  "/school/substitutes",
  "/school/tip-a-teacher",
  "/school/tuition",
  "/administrator/tuition",
  "/super-administrator/control-plane",
  "/parent/portal",
  "/parent/portal--new"
];

export const PARENT_PORTAL_CANONICAL_PREFIX = "/parent/portal";

export const PARENT_PORTAL_ALIAS_PREFIX = "/parent/portal--new";

export const PARENT_PORTAL_PREFIXES: string[] = [

  PARENT_PORTAL_CANONICAL_PREFIX,

  PARENT_PORTAL_ALIAS_PREFIX,

];

export const CANONICAL_PUBLIC_ROUTES: string[] = [
  "/apply",
  "/auth",
  "/redirect"
];

export const POST_AUTH_PUBLIC_ROUTES: string[] = [
  "/apply",
  "/redirect"
];

export const PUBLIC_ROUTE_REWRITE_MAP: Record<string, string> = {
  "/": "/apply",
  "/apply": "/apply",
  "/redirect": "/apply"
};

export const LEGACY_SHELL_ALIAS_REWRITES: PrefixRewriteRule[] = [
  {
    "fromPrefix": "/admissions",
    "toPrefix": "/school/admissions",
    "defaultPath": "/school/admissions/dashboard"
  },
  {
    "fromPrefix": "/admin/admissions",
    "toPrefix": "/school/admissions",
    "defaultPath": "/school/admissions/dashboard"
  },
  {
    "fromPrefix": "/financial-aid",
    "toPrefix": "/school/financialaid",
    "defaultPath": "/school/financialaid/dashboard"
  },
  {
    "fromPrefix": "/admin/financial-aid",
    "toPrefix": "/school/financialaid",
    "defaultPath": "/school/financialaid/dashboard"
  },
  {
    "fromPrefix": "/admin/attendance",
    "toPrefix": "/school/attendance",
    "defaultPath": "/school/attendance"
  },
  {
    "fromPrefix": "/admin/substitutes",
    "toPrefix": "/school/substitutes",
    "defaultPath": "/school/substitutes"
  },
  {
    "fromPrefix": "/admin/academics",
    "toPrefix": "/school/academics",
    "defaultPath": "/school/academics"
  },
  {
    "fromPrefix": "/admin/finance",
    "toPrefix": "/school/finance",
    "defaultPath": "/school/finance"
  },
  {
    "fromPrefix": "/admin/payroll",
    "toPrefix": "/school/payroll",
    "defaultPath": "/school/payroll"
  },
  {
    "fromPrefix": "/admin/faculty",
    "toPrefix": "/school/faculty",
    "defaultPath": "/school/faculty"
  },
  {
    "fromPrefix": "/admin/camps",
    "toPrefix": "/school/camps",
    "defaultPath": "/school/camps"
  },
  {
    "fromPrefix": "/admin/tuition",
    "toPrefix": "/administrator/tuition",
    "defaultPath": "/administrator/tuition"
  }
];

export const PORTAL_FAMILY_ALIAS_REWRITES: PrefixRewriteRule[] = [
  {
    "fromPrefix": "/portal/family",
    "toPrefix": "/parent/portal",
    "defaultPath": "/parent/portal/dashboard"
  },
  {
    "fromPrefix": "/portal/family/intake/applications",
    "toPrefix": "/parent/portal--new/applications",
    "defaultPath": "/parent/portal--new/applications"
  },
  {
    "fromPrefix": "/portal/family/applications",
    "toPrefix": "/parent/portal/applications",
    "defaultPath": "/parent/portal/applications"
  },
  {
    "fromPrefix": "/portal/family/parent/dashboard",
    "toPrefix": "/parent/portal/dashboard",
    "defaultPath": "/parent/portal/dashboard"
  },
  {
    "fromPrefix": "/portal/family/dashboard",
    "toPrefix": "/parent/portal/dashboard",
    "defaultPath": "/parent/portal/dashboard"
  },
  {
    "fromPrefix": "/portal/family/enrollment",
    "toPrefix": "/parent/portal/enrollment"
  },
  {
    "fromPrefix": "/portal/family/financial-aid",
    "toPrefix": "/parent/portal/financialaid"
  },
  {
    "fromPrefix": "/portal/family/financialaid",
    "toPrefix": "/parent/portal/financialaid"
  },
  {
    "fromPrefix": "/portal/family/calendar",
    "toPrefix": "/parent/portal/calendar"
  },
  {
    "fromPrefix": "/portal/family/tuition",
    "toPrefix": "/parent/portal/tuition"
  },
  {
    "fromPrefix": "/portal/family/attendance",
    "toPrefix": "/parent/portal/attendance"
  },
  {
    "fromPrefix": "/portal/family/academic",
    "toPrefix": "/parent/portal/academic"
  },
  {
    "fromPrefix": "/portal/family/resources",
    "toPrefix": "/parent/portal/resources"
  },
  {
    "fromPrefix": "/portal/family/tip-teacher",
    "toPrefix": "/parent/portal/tip-a-teacher",
    "defaultPath": "/parent/portal/tip-a-teacher"
  },
  {
    "fromPrefix": "/portal/family/camps",
    "toPrefix": "/parent/portal/camps",
    "defaultPath": "/parent/portal/camps"
  },
  {
    "fromPrefix": "/portal/family/parnes-hayom",
    "toPrefix": "/parent/portal/parnes-hayom",
    "defaultPath": "/parent/portal/parnes-hayom"
  }
];

export const SETTINGS_FORBIDDEN_ALIASES: string[] = [
  "/settings",
  "/settings/general",
  "/admin/settings",
  "/admin/settings/general",
  "/portal/family/settings"
];

export const PUBLIC_FORBIDDEN_ALIASES: string[] = [
  "/public",
  "/public/apply",
  "/public/privacy-policy",
  "/public/terms-conditions"
];

export const BRIDGE_NAV_ALIASES: Array<{ prefix: string; canonical: string }> = [
  {
    "prefix": "/bridged/admissions",
    "canonical": "/school/admissions"
  },
  {
    "prefix": "/bridged/admin/faculty",
    "canonical": "/school/faculty"
  },
  {
    "prefix": "/bridged/financial-aid",
    "canonical": "/school/financialaid"
  },
  {
    "prefix": "/bridged/settings",
    "canonical": "/school/settings"
  },
  {
    "prefix": "/bridged/attendance",
    "canonical": "/school/attendance"
  },
  {
    "prefix": "/bridged/substitutes",
    "canonical": "/school/substitutes"
  },
  {
    "prefix": "/bridged/finance",
    "canonical": "/school/finance"
  },
  {
    "prefix": "/bridged/payroll",
    "canonical": "/school/payroll"
  },
  {
    "prefix": "/bridged/academics",
    "canonical": "/school/academics"
  },
  {
    "prefix": "/bridged/admin/faculty",
    "canonical": "/school/faculty"
  },
  {
    "prefix": "/admin/admissions",
    "canonical": "/school/admissions"
  },
  {
    "prefix": "/admin/faculty",
    "canonical": "/school/faculty"
  },
  {
    "prefix": "/admin/financial-aid",
    "canonical": "/school/financialaid"
  },
  {
    "prefix": "/admissions",
    "canonical": "/school/admissions"
  },
  {
    "prefix": "/financial-aid",
    "canonical": "/school/financialaid"
  },
  {
    "prefix": "/bridged/portal/family",
    "canonical": "/parent/portal"
  },
  {
    "prefix": "/bridged/parent-portal",
    "canonical": "/parent/portal"
  },
  {
    "prefix": "/portal/family",
    "canonical": "/parent/portal"
  },
  {
    "prefix": "/bridged/portal/family/tip-a-teacher",
    "canonical": "/parent/portal/tip-a-teacher"
  }
];

export const BRIDGE_CANONICAL_TO_BRIDGED: Array<{ canonical: string; bridged: string }> = [
  {
    "canonical": "/school/admissions",
    "bridged": "/bridged/admissions"
  },
  {
    "canonical": "/school/faculty",
    "bridged": "/bridged/admin/faculty"
  },
  {
    "canonical": "/school/financialaid",
    "bridged": "/bridged/financial-aid"
  },
  {
    "canonical": "/school/settings",
    "bridged": "/bridged/settings"
  },
  {
    "canonical": "/school/attendance",
    "bridged": "/bridged/attendance"
  },
  {
    "canonical": "/school/substitutes",
    "bridged": "/bridged/substitutes"
  },
  {
    "canonical": "/school/finance",
    "bridged": "/bridged/finance"
  },
  {
    "canonical": "/school/payroll",
    "bridged": "/bridged/payroll"
  },
  {
    "canonical": "/school/academics",
    "bridged": "/bridged/academics"
  },
  {
    "canonical": "/school/faculty",
    "bridged": "/bridged/admin/faculty"
  },
  {
    "canonical": "/admissions",
    "bridged": "/bridged/admissions"
  },
  {
    "canonical": "/financial-aid",
    "bridged": "/bridged/financial-aid"
  },
  {
    "canonical": "/parent/portal/dashboard",
    "bridged": "/bridged/portal/family/dashboard"
  },
  {
    "canonical": "/parent/portal/applications",
    "bridged": "/bridged/portal/family/applications"
  },
  {
    "canonical": "/parent/portal/enrollment",
    "bridged": "/bridged/portal/family/enrollment"
  },
  {
    "canonical": "/parent/portal/financialaid",
    "bridged": "/bridged/portal/family/financialaid"
  },
  {
    "canonical": "/parent/portal/settings",
    "bridged": "/bridged/portal/family/settings"
  },
  {
    "canonical": "/parent/portal/calendar",
    "bridged": "/bridged/portal/family/calendar"
  },
  {
    "canonical": "/parent/portal/tuition",
    "bridged": "/bridged/portal/family/tuition"
  },
  {
    "canonical": "/parent/portal/attendance",
    "bridged": "/bridged/portal/family/attendance"
  },
  {
    "canonical": "/parent/portal/academic",
    "bridged": "/bridged/portal/family/academic"
  },
  {
    "canonical": "/parent/portal/resources",
    "bridged": "/bridged/portal/family/resources"
  },
  {
    "canonical": "/parent/portal",
    "bridged": "/bridged/portal/family"
  },
  {
    "canonical": "/parent/portal--new",
    "bridged": "/bridged/portal/family"
  },
  {
    "canonical": "/portal/family/applications",
    "bridged": "/bridged/portal/family/applications"
  },
  {
    "canonical": "/portal/family/enrollment",
    "bridged": "/bridged/portal/family/enrollment"
  },
  {
    "canonical": "/portal/family/financial-aid",
    "bridged": "/bridged/portal/family/financialaid"
  },
  {
    "canonical": "/portal/family/financialaid",
    "bridged": "/bridged/portal/family/financialaid"
  },
  {
    "canonical": "/portal/family/calendar",
    "bridged": "/bridged/portal/family/calendar"
  },
  {
    "canonical": "/portal/family/tuition",
    "bridged": "/bridged/portal/family/tuition"
  },
  {
    "canonical": "/portal/family/attendance",
    "bridged": "/bridged/portal/family/attendance"
  },
  {
    "canonical": "/portal/family/academic",
    "bridged": "/bridged/portal/family/academic"
  },
  {
    "canonical": "/portal/family/resources",
    "bridged": "/bridged/portal/family/resources"
  },
  {
    "canonical": "/parent/portal/tip-a-teacher",
    "bridged": "/bridged/portal/family/tip-a-teacher"
  },
  {
    "canonical": "/portal/family/tip-teacher",
    "bridged": "/bridged/portal/family/tip-a-teacher"
  },
  {
    "canonical": "/portal/family",
    "bridged": "/bridged/portal/family"
  },
  {
    "canonical": "/parent/portal/donations",
    "bridged": "/bridged/donations"
  }
];

export const BRIDGED_INDEX_ROOTS_FROM_POLICY: string[] = [
  "/bridged/admissions",
  "/bridged/admin/faculty",
  "/bridged/financial-aid",
  "/bridged/settings",
  "/bridged/portal/family/applications",
  "/bridged/portal/family/enrollment",
  "/bridged/portal/family/financialaid",
  "/bridged/portal/family/calendar",
  "/bridged/portal/family/tuition",
  "/bridged/portal/family/attendance",
  "/bridged/portal/family/academic",
  "/bridged/portal/family/resources",
  "/bridged/portal/family/settings",
  "/bridged/portal/family/tip-a-teacher",
  "/bridged/attendance",
  "/bridged/academics",
  "/bridged/substitutes",
  "/bridged/finance",
  "/bridged/donations",
  "/bridged/admin/faculty",
  "/bridged/portal/family"
];

export const HIERARCHY_ALLOWED_PUBLIC_ROUTES: string[] = [
  "/apply",
  "/redirect"
];

export const VITE_STATIC_ROUTE_ALIASES: Record<string, string> = {
  "/admissions": "/bridged/admissions",
  "/financial-aid": "/bridged/financial-aid",
  "/school/admissions": "/bridged/admissions",
  "/school/financialaid": "/bridged/financial-aid",
  "/school/settings": "/bridged/settings",
  "/parent/portal": "/bridged/portal/family",
  "/parent/portal--new": "/bridged/portal/family",
  "/portal/family": "/bridged/portal/family",
  "/admin/admissions": "/bridged/admissions",
  "/admin/financial-aid": "/bridged/financial-aid"
};

export const VITE_ALWAYS_STATIC_SUBAPPS: string[] = [
  "/admissions",
  "/financial-aid"
];

export const VITE_SUBAPP_PREFIXES: string[] = [
  "/bridged/portal/family/tip-a-teacher",
  "/bridged/attendance",
  "/bridged/academics",
  "/bridged/substitutes",
  "/bridged/finance",
  "/bridged/donations",
  "/bridged/admin/faculty",
  "/bridged/admissions",
  "/bridged/financial-aid",
  "/bridged/settings",
  "/admissions",
  "/financial-aid",
  "/school/admissions",
  "/school/financialaid",
  "/school/settings",
  "/parent/portal",
  "/parent/portal--new",
  "/portal/family",
  "/admin/admissions",
  "/admin/financial-aid"
];
